import {useEffect, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {useParams} from 'react-router-dom';

import {RootState} from '../../../../../store/redux';
import AddSaleAgents from '../../elements/addSaleAgents';
import DotsLoading from '../../../../../components/dotsLoading';
import SaleAgentsListing from '../saleAgentsListing/SaleAgentsListing';
import {clearSaleAgentForm} from '../../../../../store/redux/salesAgent';
import MainFooter from '../../../../../components/mazraeKit/footers/footerMain';
import CustomHeader from '../../../../../components/mazraeKit/headers/homeHeader';
import {clearAddress} from '../../../../../store/redux/saleAgentsSelectedLocation';
import useGetSaleAgentsList from '../../../../../services/hookService/getSaleAgentsList/useGetSaleAgentsList';

function SalesAgents() {
  const params = useParams();
  const dispatch = useDispatch();

  const state = useSelector((state: RootState) => state.saleAgentsLocation);

  const [saleAgentsBottomSheet, setSaleAgentsBottomSheet] =
    useState<ISaleAgentBottomSheetProps>({
      position: false,
      type: 'editDelete',
    });

  const {saleAgentList, isLoading, refetchGetSaleAgentList} =
    useGetSaleAgentsList(params?.assigner_store as string);

  useEffect(() => {
    if (state?.location && state?.location?.length > 0) {
      setSaleAgentsBottomSheet({
        ...saleAgentsBottomSheet,
        type: 'addEdit',
        position: true,
      });
    }
  }, [state.location]);

  return (
    <div className="flex flex-col h-full">
      <CustomHeader
        title="عاملین فروش"
        preIcon="icon-nameArrow---Right"
        isActiveRightIcon
      />
      {isLoading ? (
        <div className="flex h-full justify-center items-center">
          <DotsLoading />
        </div>
      ) : (
        <div className="flex flex-col h-full overflow-y-auto gap-3 p-3">
          {saleAgentList && saleAgentList.length > 0 ? (
            <SaleAgentsListing
              {...{
                isLoading,
                saleAgentList,
                saleAgentsBottomSheet,
                setSaleAgentsBottomSheet,
                refetchGetSaleAgentList,
              }}
              assigner_store={params?.assigner_store as string}
            />
          ) : (
            <AddSaleAgents
              {...{
                saleAgentsBottomSheet,
                setSaleAgentsBottomSheet,
                refetchGetSaleAgentList,
              }}
              assigner_store={params?.assigner_store as string}
            />
          )}
        </div>
      )}
      <div>
        <button
          className="flex justify-center items-center bg-farm-shop-500 w-full h-12 my-5 gap-2 rounded text-white max-w-52 mx-auto"
          onClick={() => {
            dispatch(clearSaleAgentForm());
            dispatch(clearAddress());
            setSaleAgentsBottomSheet({
              position: true,
              type: 'addEdit',
            });
          }}
        >
          <i className="icon-namePlus-4" />
          <span>افزودن عامل فروش</span>
        </button>
      </div>
      <MainFooter />
    </div>
  );
}

export default SalesAgents;
